import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { guideContent } from "@/mocks/guide-content";

export default function GuidePage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <article>
          <section className="w-full pt-32 pb-16 md:pt-40 md:pb-20 bg-background-50">
            <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <Link
                  to="/"
                  className="text-sm text-secondary-600 hover:text-secondary-700 font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
                >
                  <i className="ri-arrow-left-line"></i>
                  Home
                </Link>
                <span className="text-foreground-400">/</span>
                <Link
                  to="/shopping-guide"
                  className="text-sm text-secondary-600 hover:text-secondary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  Shopping Guide
                </Link>
                <span className="text-foreground-400">/</span>
                <span className="text-sm text-foreground-500">Complete Guide</span>
              </div>

              <span className="text-xs font-semibold text-secondary-600 uppercase tracking-widest">
                Complete Guide
              </span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mt-3 mb-4 leading-tight">
                {guideContent.title}
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                {guideContent.subtitle}
              </p>
              <div className="flex items-center gap-4 mt-6 pb-8 border-b border-background-200/70">
                <span className="text-xs text-foreground-500">Last updated: June 2026</span>
                <span className="text-xs text-foreground-500">•</span>
                <span className="text-xs text-foreground-500">8 min read</span>
              </div>
            </div>
          </section>

          <section className="w-full py-10 md:py-14 bg-background-50">
            <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
              <div className="prose-custom">
                {guideContent.sections.map((section, idx) => (
                  <div key={idx} className="mb-10 md:mb-14">
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                      {section.heading}
                    </h2>
                    <div className="text-base text-foreground-700 leading-relaxed space-y-4">
                      {section.content.split("\n\n").map((paragraph, pIdx) => (
                        <p key={pIdx}>{paragraph}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-12 pt-10 border-t border-background-200/70">
                <div className="bg-background-100 rounded-2xl p-6 md:p-8 text-center">
                  <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
                    Ready to Start Shopping?
                  </h3>
                  <p className="text-sm text-foreground-600 mb-6 max-w-md mx-auto">
                    Browse curated spreadsheets across 14 product categories and find the best deals from verified China shopping agents.
                  </p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-8 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
                    >
                      itaobuy sheet
                    </a>
                    <Link
                      to="/shopping-guide"
                      className="bg-foreground-950 hover:bg-foreground-800 text-background-50 font-semibold px-8 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
                    >
                      Browse All Guides
                    </Link>
                    <Link
                      to="/"
                      className="text-sm text-foreground-600 hover:text-foreground-950 font-medium transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Back to Home
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: guideContent.title,
            description: guideContent.subtitle,
            image: "https://readdy.ai/api/search-image?query=Clean%20workspace%20with%20laptop%20displaying%20spreadsheet%20and%20fashion%20product%20photos%2C%20dark%20walnut%20desk%2C%20natural%20daylight%2C%20editorial%20lifestyle%20photography%2C%20warm%20tones%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-guide-jun27&orientation=landscape",
            datePublished: "2026-06-27",
            dateModified: "2026-06-27",
            author: { "@type": "Organization", name: "itaobuy.cam" },
            publisher: { "@type": "Organization", name: "itaobuy.cam", logo: { "@type": "ImageObject", url: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg" } },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://itaobuy.cam/itaobuyspreadsheet-guide"
            },
            inLanguage: "en-US",
          }),
        }}
      />
    </>
  );
}